import React, { Component, Fragment } from 'react';

import { Form } from 'components/form';
import { Loader } from 'components/loader';
import { Toggle } from 'components/toggle';
import { I18n } from 'components/translate';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import { ContentBasePage } from 'modules/content';
import PropTypes from 'prop-types';

import SalesService from '../SalesService';

import './SalesSubscriptionDetails.scss';

@inject('MembershipStore')
export default class SalesSubscriptionDetails extends Component {
  static propTypes = {
    MembershipStore: MobxPropTypes.objectOrObservableObject,
    fixedBarId: PropTypes.string
  };

  state = {
    loading: true,
    lifetimeAccessEnabled: false
  };

  componentDidMount() {
    this.setState({
      lifetimeAccessEnabled: this.props.MembershipStore.isLifetimeAccessEnabled
    });

    this.disableLoader();
  }

  enableLoader() {
    this.setState({ loading: true });
  }

  disableLoader() {
    this.setState({ loading: false });
  }

  toggleOnChangeHandler = (event) => {
    this.setState({
      lifetimeAccessEnabled: event.target.value
    });
  };

  save = async () => {
    this.enableLoader();

    this.state.lifetimeAccessEnabled
      ? await SalesService.enableLifetimeAccess()
      : await SalesService.disableLifetimeAccess();

    this.disableLoader();
  };

  render() {
    const { loading, lifetimeAccessEnabled } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loader key="loader" fixed />
        ) : (
          <Form
            className="sales_subscription"
            ref={(node) => (this.formNode = node)}
            onSubmit={this.save.bind(this)}
          >
            <div className="grid grid__block">
              <div className="card__description">
                <h2>
                  <I18n label="sales_manager.subscription_details" />
                </h2>
              </div>
              <div className="sales__toggle__wrapper">
                <div className="sales_toggle__wrapper__label">
                  <label>
                    <I18n label="sales_manager.activate_lifetime_access_text" />
                  </label>
                </div>
                <Toggle
                  onChange={this.toggleOnChangeHandler}
                  checked={lifetimeAccessEnabled}
                />
              </div>
            </div>

            <ContentBasePage.Footer onlySave />
          </Form>
        )}
      </Fragment>
    );
  }
}
